import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import Shimmer from "react-shimmer-effect";

import { Tooltip, Row, Col } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/skpService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"
import CustomSelect from "../../../../../helpers/ui/CustomSelect";

const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear(), years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear + 3 ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
  }
class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historySKPDataTableXActive'
    defaultOrder = 'skp_period_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            year : new Date().getFullYear(),
            tooltip: false,
            sikapuuid: null,
            perioduuid: null,
            selesaipuuid: null,
            realisasiuuid: null,
            updateUuid: null,
            inactiveUuid: null,
            pengukuranuuid: null,
            currentmonth : new Date().getMonth() + 1,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            lastperiod: null,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            year : this.state.year,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchDelete({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        detail: response.employee,
                        lastperiod: response.lastperiod,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.deleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        // console.log("ini bulan")
        // console.log(this.state.currentmonth)
    }
    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
        this.dataTableBloc.deleteChannel.unsubscribe()
    }

    columns = [
        {
            key: "skp_period_year",
            text: "Tahun",
            className: "skp_period_year",
            sortable: true,
            width: '80'
        },
        {
            key: "skp_period_start_date",
            text: "Tanggal Mulai",
            className: "skp_period_start_date",
            sortable: true,
            width: '150',
            cell: record => {
                return this.dateParse(record.skp_period_start_date)
            }
        },
        {
            key: "skp_period_end_date",
            text: "Tanggal Selesai",
            className: "skp_period_end_date",
            sortable: true,
            width: '150',
            cell: record => {
                return this.dateParse(record.skp_period_end_date)
            }
        },
        {
            key: "skp_period_employee_position_name",
            text: "Jabatan",
            className: "skp_period_employee_position_name",
            sortable: true,
        },
        {
            key: "skp_period_employee_work_unit_name",
            text: "Unit Kerja",
            className: "skp_period_employee_work_unit_name",
            sortable: true,
        },
        {
            key: "skp_period_status_name",
            text: "Status",
            className: "skp_period_status_name",
            sortable: true,
            width: '100',
            cell: record => {
                return <label className={`badge rounded-pill ${record.skp_period_status_class} font-size-12`}>{record.skp_period_status_name}</label>
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.skp_period_id
                return (
                    <Fragment>
                    {/* {
                        (record.skp_period_status == 7)?
                        <span>
                            <button
                                className="btn btn-success btn-sm"
                                id={"selesai-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        selesaipuuid: record.skp_period_uuid,
                                        euuid: record.skp_period_employee_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["selesai" + thisId]} target={"selesai-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["selesai" + thisId] : !this.state["selesai" + thisId]
                                    })
                                }}
                            >Detail SKP Bawahan Selesai</Tooltip>
                        </span> : ''
                    } */}
                    {
                        (record.skp_period_status >=2 && record.skp_period_status <8)?
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        perioduuid: record.skp_period_uuid,
                                        euuid: record.skp_period_employee_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >SKP Bawahan</Tooltip>
                        </span> : ''
                    }
                    {
                        (record.skp_period_status >4 && record.skp_period_status<8)?
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"realisasi-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        realisasiuuid: record.skp_period_uuid,
                                        euuid: record.skp_period_employee_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["realisasi" + thisId]} target={"realisasi-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["realisasi" + thisId] : !this.state["realisasi" + thisId]
                                    })
                                }}
                            >Realisasi SKP Bawahan</Tooltip>
                        </span> : ''
                    }
                    {
                        (record.skp_period_status >= 7)?
                        <span>
                            <button
                                className="btn btn-success btn-sm"
                                id={"pengukuran-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        pengukuranuuid: record.skp_period_uuid,
                                        euuid: record.skp_period_employee_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-check-square"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["pengukuran" + thisId]} target={"pengukuran-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["pengukuran" + thisId] : !this.state["pengukuran" + thisId]
                                    })
                                }}
                            >Pengukuran</Tooltip>
                        </span> : ''
                    }
                    {/* <div>{this.state.lastperiod?.skp_period_uuid + ' - ' + record.skp_period_uuid}</div> */}
                    {
                        (record.skp_period_status >=8 && record.is_penilaian!= '' && this.state.lastperiod?.skp_period_uuid == record.skp_period_uuid)?
                        <span>
                            <button
                                className="btn btn-info btn-sm"
                                id={"sikap-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        sikapuuid: record.skp_period_uuid,
                                        // perioduuid: record.skp_period_uuid,
                                        euuid: record.skp_period_employee_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-file-search-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["sikap" + thisId]} target={"sikap-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["sikap" + thisId] : !this.state["sikap" + thisId]
                                    })
                                }}
                            >Penilaian Perilaku</Tooltip>
                        </span> : ''
                    }
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <div>
                    <Row className="mb-3">
                        <label className="col-md-2">
                        NIP
                        </label>
                        <Col md="8">
                            {
                                this.state.detail ?
                                    <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                            }
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label className="col-md-2">
                        Nama
                        </label>
                        <Col md="8">
                            {
                                this.state.detail ?
                                    <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                            }
                        </Col>
                    </Row>
                    {/* <Row className="mb-3">
                        <label className="col-md-2">
                        Tempat, Tanggal Lahir
                        </label>
                        <Col md="8">
                            {
                                this.state.detail ?
                                    <>{this.getEmployeeBirthDetail(this.state.detail)}</>
                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                            }
                        </Col>
                    </Row> */}
                    <Row className="mb-3">
                        <label className="col-md-2">
                        Jabatan
                        </label>
                        <Col md="8">
                            {
                                this.state.detail ?
                                    <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                            }
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label className="col-md-2">
                        Unit Kerja
                        </label>
                        <Col md="8">
                            {
                                this.state.detail ?
                                    <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                            }
                        </Col>
                    </Row>
                </div>

                <hr />
                <Row className="mb-2">
                    {/* <label
                        htmlFor="no_sk"
                        className="col-md-1 col-form-label"
                    >
                    Tahun <span className="text-danger">*</span>
                    </label> */}
                    <Col md="2">
                        <CustomSelect 
                            isAvForm={false}
                            name="skp_header_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions} 
                            // validate={{ required: { value: true } }}
                            onChange={opt => {
                                this.setState({ year: opt.value });

                                setTimeout(() => {
                                    this.setTokenAPI()
                                }, 300)
                                
                            }}
                            placeholder="Pilih Tahun"
                            defaultValue={new Date().getFullYear()}
                        />
                    </Col>
                </Row>

                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.selesaipuuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.perioduuid}/>
                    <Redirect to={"/kepegawaian/skp.html?skpselesai&euuid="+this.state.euuid+"&perioduuid=" + this.state.selesaipuuid}/>
                : null }
                { this.state.sikapuuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.perioduuid}/>
                    <Redirect to={"/kepegawaian/skp.html?penilaiansikap&euuid="+this.state.euuid+"&perioduuid=" + this.state.sikapuuid}/>
                : null }
                { this.state.perioduuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.perioduuid}/>
                    <Redirect to={"/kepegawaian/skp.html?data_kegiatan_bawahan&euuid=" + this.state.euuid+'&perioduuid='+this.state.perioduuid}/>
                : null }
                { this.state.realisasiuuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.perioduuid}/>
                    <Redirect to={"/kepegawaian/skp.html?data_kegiatan_bawahan_realisasi&euuid=" + this.state.euuid+'&perioduuid='+this.state.realisasiuuid}/>
                : null }
                { this.state.pengukuranuuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.perioduuid}/>
                    <Redirect to={"/kepegawaian/skp.html?pengukuran&euuid=" + this.state.euuid+'&perioduuid='+this.state.pengukuranuuid}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent